module.exports = __webpack_public_path__ + "static/img/background01-mercedes-2023.2902c2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/background01-mercedes-2023.jpg
// module id = C9Gq
// module chunks = 1